// 获取网页可见区域宽
export const getDocumentWidth = () => {
	return document.body.clientWidth > 617 ? true : false;
}

// 获取url信息
export const getQueryVariable = (variable: string) => {
	var query = window.location.search.split('&');
	for (var i = 0; i < query.length; i++) {
		if (query[i].indexOf('=') !== -1) {
			var pair = query[i].split("=");
			if (pair[0] == `?${variable}`) { return pair[1]; }
		}
	}
	return (false);
}
